export default __webpack_public_path__ + "static/national-metric-mobile-d341e033605ba7abd0f4966dc3242524.svg";